var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters.isMobile && _vm.$store.getters.getCurrentLevel === 3)?_c('ConfiguratorLevel3Mobile'):(_vm.$store.getters.getCurrentLevel === 3)?_c('ConfiguratorLevel3Desktop'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }